module.exports = __webpack_public_path__ + "static/media/gameFacePainting.4a921c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameFacePainting.png
// module id = 2660
// module chunks = 0